import StarIcon from 'material-ui-icons/Star'
import StarBorderIcon from 'material-ui-icons/StarBorder'
import Grid from 'material-ui/Grid'
import withStyles from 'material-ui/styles/withStyles'
import React from 'react'
import styleSheet from './AllWebChatStyle.style'

import { ListItemText, Typography } from 'material-ui'
import images from '../common/images'

class WebChatStaffReview extends React.Component {
  render() {
    const { classes, review_number, submit_review, review_id, createdAt, message, review, already_submit } = this.props
    return (
      <Grid container spacing={0}>
        <Grid item xs={1} className={classes.chat_nurseImg}>
          <img src={images.icBot} width={30} height={30} />
        </Grid>

        <Grid item xs={11} className={classes.chat_nurseContent}>
          <div className={classes.chat_chatBox}>
            <div className={classes.chat_nurseChatTail}></div>
            <div className={classes.chat_nurseChatTailSub}></div>
            <div className={classes.chat_nurseChat}>
              <ListItemText
                primary={
                  <Typography type="caption" className={classes.textBlack}>
                    {message}
                  </Typography>
                }
              />
              <div className={classes.chat_reviewScore}>
                {[...Array(5)].map((_, i) => {
                  const score = i + 1
                  return review[review_number].review_score < score ?
                      <StarBorderIcon
                        key={score}
                        className={classes.chat_starIcon}
                        onClick={() => {
                          !already_submit && this.props.setReviewState('review_score', score, review_number)
                        }}
                      />
                    : <StarIcon
                        key={score}
                        className={classes.chat_starIcon}
                        onClick={() => {
                          !already_submit && this.props.setReviewState('review_score', score, review_number)
                        }}
                      />
                })}
              </div>

              <textarea
                disabled={already_submit}
                className={classes.chat_reviewMessageArea}
                value={review[review_number].review_message}
                onChange={(e) => this.props.setReviewState('review_message', e.target.value, review_number)}
                rows="4"
                type="text"
                placeholder="回答への感想・ご意見をお書きください。&#13;&#10;※チャット回数にはカウントされません。&#13;&#10;※この欄からの健康相談をいただいてもご返信いたしかねます。"
              />
              <button
                className={submit_review}
                onClick={() => {
                  review[review_number].review_score == 0 ?
                    alert('評価をしてください')
                  : confirm('この内容で送信してもよろしいですか？') &&
                    (this.props.submitReview(review_id, review_number) || alert('ご協力ありがとうございます！'))
                }}
                disabled={review[review_number].already_submit}
              >
                <Typography className={`mplus-bold ${classes.textWhite}`}>
                  <b>送信</b>
                </Typography>
              </button>
            </div>
          </div>
          <Typography type="caption" className={classes.chat_createdAt}>
            {createdAt}
          </Typography>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styleSheet)(WebChatStaffReview)
